export default __webpack_public_path__ + "static/media/renewable-energy-progress-progress-bar.8981b7d4.png";